import * as _ from 'lodash'
import router from '@/router'
import store from '@/store'
import { judgeDevice } from '@/util/common'

// import createPersistedState from 'vuex-persistedstate'
const getDefaultState = () => {
  return {
    systemErrorInFullScreen: {
      show: false,
      title: null,
      text: null
    },
    systemError: {
      type: null, // error type
      code: null, // error code(http status)
      text: '', // error text
      show: false,
      button: {
        show: true,
        text: '閉じる'
      }
    },
    notice: {
      title: 'エラー',
      text: '',
      button1: {
        show: true,
        text: '閉じる',
        action: null
      },
      button2: {
        show: false,
        text: '',
        action: null
      },
      buttonClose: {
        show: true,
        action: null
      }
    },
    toast: {
      show: false,
      text: '',
      time: 3
    },
    device: '',
    loading: false,
    title: '',
    fromName: null, // 遷移元名
    fromPath: null, // 遷移元URL
    toName: null, // 遷移先名
    toPath: null, // 遷移先URL
    isRequireAuth: false, // 認証が必要なページ（ログイン内ページ）かどうかを判定するフラグ
    decidedNoticeTitle: '', // 確定したダイアログタイトル
    decidedNoticeMessage: '', // 確定したダイアログメッセージ
    isLoggedOut: false // ログアウト実施完了フラグ
  }
}
const defaultState = getDefaultState()

const common = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
  },
  mutations: {
    setErrorInFullScreen(state, payload) {
      state.systemErrorInFullScreen = payload
    },
    setApiError(state, payload) {
      state.systemError = payload
    },
    resetApiError(state, payload) {
      state.systemError = payload
    },
    setNotice(state, payload) {
      state.notice = payload
    },
    resetNotice(state, payload) {
      state.notice = payload
    },
    setToast(state, payload) {
      state.toast = payload
    },
    resetToast(state, payload) {
      state.toast = payload
    },
    setDevice(state, payload) {
      state.device = payload
    },
    setLoading(state) {
      state.loading = true
    },
    unsetLoading(state) {
      state.loading = false
    },
    setTitle(state, payload) {
      state.title = payload
    },
    addTitle(state, payload) {
      document.title = payload + state.title
    },
    setFromName(state, fromName) {
      state.fromName = fromName
    },
    setFromPath(state, fromPath) {
      state.fromPath = fromPath
    },
    setToName(state, toName) {
      state.toName = toName
    },
    setToPath(state, toPath) {
      state.toPath = toPath
    },
    setIsRequireAuth(state, isRequireAuth) {
      state.isRequireAuth = isRequireAuth
    },
    setDecidedNoticeTitle(state, decidedNoticeTitle) {
      state.decidedNoticeTitle = decidedNoticeTitle
    },
    setDecidedNoticeMessage(state, decidedNoticeMessage) {
      state.decidedNoticeMessage = decidedNoticeMessage
    },
    setIsLoggedOut(state, isLoggedOut) {
      state.isLoggedOut = isLoggedOut
    }
  },
  actions: {
    // 全画面エラー
    showErrorInFullScreen({ commit }, payload) {
      commit('setErrorInFullScreen', payload)
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPError', params: payload })
      } else {
        router.push({ name: 'PCError', params: payload })
      }
    },
    showError({ commit }, payload) {
      // デフォルト値に対してペイロードをマージ
      const data = _.cloneDeep(defaultState.systemError)
      _.merge(data, payload)

      data.show = true
      commit('setApiError', data)
    },
    hideError({ commit }) {
      commit('resetApiError', defaultState.systemError)
    },
    showNotice({ commit }, payload) {
      if (store.state.login.isTimeoutMessageShown) {
        // タイムアウトエラーを表示した場合はNoticeの文言をタイムアウトのメッセージで固定する
        payload = { title: 'タイムアウト', text: 'タイムアウトしました。ログイン画面に戻ります。' }
      }

      // デフォルト値に対してペイロードをマージ
      const data = _.cloneDeep(defaultState.notice)
      _.merge(data, payload)

      data.show = true
      commit('setNotice', data)
    },
    hideNotice({ commit }) {
      commit('resetNotice', defaultState.notice)
    },
    showToast({ commit }, payload) {
      const data = _.cloneDeep(defaultState.toast)
      _.merge(data, payload)

      data.show = true
      commit('setToast', data)
    },
    hideToast({ commit }) {
      commit('resetToast', defaultState.toast)
    },
    setDevice({ commit }) {
      const device = judgeDevice()
      commit('setDevice', device)
    },
    showLoading({ commit }) {
      commit('setLoading')
    },
    hideLoading({ commit }) {
      commit('unsetLoading')
    },
    setTitle({ commit }, payload) {
      commit('setTitle', payload)
    },
    addTitle({ commit }, payload) {
      commit('addTitle', payload)
    },
    // 遷移元名
    setFromName({ commit }, fromName) {
      commit('setFromName', fromName)
    },
    setFromPath({ commit }, fromPath) {
      commit('setFromPath', fromPath)
    },
    // 遷移先名
    setToPath({ commit }, toPath) {
      commit('setToPath', toPath)
    },
    setToName({ commit }, toName) {
      commit('setToName', toName)
    },
    // 認証が必要なページ（ログイン内ページ）かどうかを判定するフラグ
    setIsRequireAuth({ commit }, isRequireAuth) {
      commit('setIsRequireAuth', isRequireAuth)
    },
    // 確定したダイアログタイトル
    // （APIが並列実行される場合に後勝ちでダイアログタイトルとメッセージが表示されるため、
    // このメソッドを使って表示したいタイトル・メッセージを保持する）
    setDecidedNoticeTitle({ commit }, decidedNoticeTitle) {
      commit('setDecidedNoticeTitle', decidedNoticeTitle)
    },
    // 確定したダイアログメッセージ
    // （APIが並列実行される場合に後勝ちでダイアログタイトルとメッセージが表示されるため、
    // このメソッドを使って表示したいタイトル・メッセージを保持する）
    setDecidedNoticeMessage({ commit }, decidedNoticeMessage) {
      commit('setDecidedNoticeMessage', decidedNoticeMessage)
    },
    // ログアウト実施完了フラグ
    setIsLoggedOut({ commit }, isLoggedOut) {
      commit('setIsLoggedOut', isLoggedOut)
    }
  }
}

export default common
